import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import MinutesToText from 'modules/attendance/components/MinutesToText'

import Bar from './Bar'

interface Props {
  totalTransfers: number
  totalTransfersTimeOff: number
  totalTransfersCompensatedPayroll: number
  totalTransfersPendingToCompensatePayroll: number
}

const Header = ({
  totalTransfers,
  totalTransfersTimeOff,
  totalTransfersCompensatedPayroll,
  totalTransfersPendingToCompensatePayroll,
}: Props) => (
  <Box paddingTop="s12" paddingBottom="s4" paddingX="s24" gap="s8">
    <Text size="300" weight="semibold" color="grey1000">
      {i18n.t('clock_in.sidepanel.compensation.title')}
    </Text>
    <MinutesToText color="grey1000" value={totalTransfers} size="500" weight="medium" />
    <Bar
      totalTransfersTimeOff={totalTransfersTimeOff}
      totalTransfersCompensatedPayroll={totalTransfersCompensatedPayroll}
      totalTransfersPendingToCompensatePayroll={totalTransfersPendingToCompensatePayroll}
    />
  </Box>
)

export default Header
